<template>
<div class="services">
  <div class="row">

    <div @click="$router.push('/trade')" class="box">
        <img src="../../assets/Home/global.png" alt="">
        <div><span>بازار</span><span style="color:#1199FA"> جهانی </span></div>
      <p>معامله تمام ارز‌های دیجیتال بر اساس تتر</p>
    </div>

    <div @click="$router.push('/trade')" class="box">
        <img src="../../assets/Home/iran.png" alt="">
      <div><span>بازار</span><span style="color:#A5A6F6"> ایران </span></div>
      <p>معامله تمام ارز های دیجیتال بر مبنای تومان</p>
    </div>

    <div @click="$router.push('/goldTrade')" class="box">
      <img src="../../assets/Home/gold.png" alt="">
      <div><span>بازار</span><span style="color:#D7B53E">  طلا</span></div>
      <p>معامله آسان طلا</p>
    </div>

    <div  @click="$router.push('/panel')" class="box">
      <img src="../../assets/Home/user.png" alt="">
      <div><span>پنل</span><span style="color:#04B3A2">  کاربری  </span></div>
      <p>مشاهده عملکرد و دارایی خود در یک نگاه</p>
    </div>

  </div>

  <div @click="$router.push('/trade')" class="row">
    <div class="box">
      <img src="../../assets/Home/chart.png" alt="">
      <div><span>تحلیل</span><span style="color:#1199FA"> ارزها </span></div>
      <p>مشاهده قیمت و نمودار تمام ارز‌ها در هر بازه زمانی</p>
    </div>

    <div class="box">
      <img src="../../assets/Home/edu.png" alt="">
      <div><span>وبلاگ و </span><span style="color:#A5A6F6"> آموزش </span></div>
      <p>اخبار تمام ارز‌ها و آموزش حرفه‌ای معامله ارز دیجیتال</p>
    </div>

    <div @click="$router.push('/otc')" class="box">
      <img src="../../assets/Home/restore.png" alt="">
      <div><span>پنل</span><span style="color:#D7B53E">  OTC  </span></div>
      <p>خرید سریع ارز بدون واسطه</p>
    </div>

    <div @click="$router.push('/panel/wallet')" class="box">
      <img src="../../assets/Home/wallet.png" alt="">
      <div><span>کیف پول</span><span style="color:#04B3A2">  امن</span></div>
      <p>واریز و برداشت رمزارزی یا تومانی در کیف پول</p>
    </div>

  </div>
</div>
</template>

<script>
export default {
  name: "the-services"
}
</script>

<style lang="scss" scoped>
.services{
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 44px;
  justify-content: center;
  direction: rtl;
  margin: 100px 0;
  align-items: center;
}

.row{
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap:20px;
  width: 90%;

  .box{
    background: #0B1426;
    box-shadow: 0 0 14px -1px rgba(255, 255, 255, 0.06);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    text-align: right;
    padding: 16px;
    direction: rtl;
    font-size: clamp(14px , 2vw , 16px);
    color: #FBFBFD;
    height: 145px;
    width: 230px;
    cursor: pointer;

    p{
      font-size: clamp(12px , 2vw , 14px);
    }

    img{
      width: 20px;
      height: 20px;
    }
  }
}
@media (max-width: 400px){
  .services{
    margin:1rem;
  }
}
</style>